import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the Settings page holder still reads from the workspace: the open setting and its switcher (also driven by the URL), permissions, the counts shown in the sidebar and the shared team / dropdown state passed to the sections.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmSettingsPageHost = Pick<
  PmWorkspaceComponent,
  | 'activeDropdown'
  | 'activeSettingItem'
  | 'applyCustomLabels'
  | 'automationError'
  | 'automationLoading'
  | 'automationSettings'
  | 'customFields'
  | 'effectiveDirectoryParentUserId'
  | 'getCustomLabel'
  | 'getTotalServicesCount'
  | 'permissionsAccess'
  | 'primaryBrandColor'
  | 'reminders'
  | 'setSettingActive'
  | 'settingsTabSwitching'
  | 'teamApiLoading'
  | 'teamMembersApi'
  | 'toggleDropdown'
>;

export const PM_SETTINGS_PAGE_HOST = new InjectionToken<PmSettingsPageHost>('PmSettingsPageHost');
